import React, { useState } from "react";

import { Button, Modal, MultiTypeDownloadToolTip, } from "@king-ict/eupisi-ui/components";
import { ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { useTypedSelector } from "../app/rootReducer";
import { useAppDispatch } from "../app/store";
import { SaveResult } from "../models";
import { resetIsEdited, setSaveOK } from "../slices/applicationSlice";
import styles from "./Toolbar.module.scss";

export interface ToolbarEditProps {
  children?: any;
  showDownload?: "hide" | "show";
  showDelete?: "hide" | "disable" | "show";
  showSave?: "hide" | "disable" | "show";
  showCancel?: "hide" | "disable" | "show";
  showCustom?: boolean;
  isEdited?: boolean;
  onClickDownload?: any;
  onClickChangeFormat?: any;
  handleSave?: () => Promise<SaveResult<any>>;
  redirectUrlSaveOK?: (id: any) => string;
  setSaveErrors?: any;
  onClickSave?: (event: React.MouseEvent<any, MouseEvent>) => void;
  onClickDelete?: (event: React.MouseEvent<any, MouseEvent>) => void;
  onClickCancel?: (event: React.MouseEvent<any, MouseEvent>) => void;
}

export const ToolbarEdit = ({
  children, showSave, showCancel, showDownload, showDelete, showCustom,
  onClickDownload, onClickChangeFormat,
  handleSave, redirectUrlSaveOK, setSaveErrors, onClickSave,
  onClickDelete, onClickCancel }: ToolbarEditProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [exportType, setExportType] = useState<number>(ExportTypeEnum.Excel);


  const dispatch = useAppDispatch();
  const isEdited: boolean = useTypedSelector((state) => state.application.isEdited);

  /// ------ EVENTS
  const handleChangeFormat = (typeId: number) => {
    setExportType(typeId)
    onClickChangeFormat(typeId);
  };
  const onClickSaveBtn = (e: any) => {
    if (handleSave) {
      handleSave?.().then((result) => {
        if (result && result.result !== undefined) {
          if (result.isValid) {
            dispatch(resetIsEdited())
            dispatch(setSaveOK())
            history.replace({
              pathname: redirectUrlSaveOK?.(result.result?.id || result.result)
            })
          }
          setSaveErrors(result.validationFailures);
        } else {
          setSaveErrors([{ propertyName: "000", message: "Sistmeska greška, molim pokušajte kasnije" }]);
        }
      }
      ).catch((error) => {
        console.log("error");
      });
    }
    else onClickSave?.(e);
  }
  /// ------ RENDER
  const DownloadButton = () => {
    switch (showDownload) {
      case "show":
        return (
          <MultiTypeDownloadToolTip
            withOverlay={true}
            exportType={exportType}
            onclick={onClickDownload}
            changeFormat={handleChangeFormat}
          ></MultiTypeDownloadToolTip>
        )
      default:
        return (<></>)
    }
  }
  const SaveButton = () => {
    if (showSave === "hide")
      return (<></>)
    else if (showSave === "show" && isEdited)
      return (<Button className="mr-1 float-right" outline={false} size="sm" onClick={onClickSaveBtn}>{t("common.save")}</Button>);
    else if (showSave === "disable" || !isEdited)
      return (<Button className="mr-1 float-right" outline={false} size="sm" disabled={true}>{t("common.save")}</Button>);
    else
      return (<></>)
  }
  const CancelButton = () => {
    switch (showCancel) {
      case "show":
        return (<>
          <Button
            className="mr-1 float-right"
            outline={true}
            size="sm"
            onClick={onClickCancel ? onClickCancel : () => history.goBack()}
          >
            {t("common.quit")}
          </Button>
        </>);
      case "disable":
        return (<Button className="mr-1 float-right" outline={true} size="sm" disabled={true}>{t("common.quit")}</Button>);
      default:
        return (<></>)
    }
  }
  const DeleteButton = () => {
    switch (showDelete) {
      case "show":
        return (<>
          <Button
            className="mr-1 float-right"
            color="danger"
            outline={true} size="sm"
            onClick={() => setShowDeleteModal(true)}
          >
            {t("common.delete")}
          </Button>
          <Modal
            type={"confirm"}
            title={t("common.deleteModalTitle")}
            cancelText={t("common.no")}
            confirmText={t("common.yes")}
            open={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onConfirm={onClickDelete}
          >
            {t("common.deleteModalMessage")}
          </Modal>
        </>);
      case "disable":
        return (<Button className="mr-1 float-right" color="danger" outline={true} size="sm" disabled={true}>{t("common.delete")}</Button>);
      default:
        return (<></>)
    }
  }
  const CustomButton = () =>
    showCustom ? (<>{children}</>) : (<></>);

  return (
    <>
      <div className={styles.toolbar}>
        <Row className="">
          <Col lg="3">
            {DownloadButton()}
          </Col>
          <Col lg="3"></Col>
          <Col lg="6" >
            {CustomButton()}
            {SaveButton()}
            {DeleteButton()}
            {CancelButton()}
          </Col>
        </Row>
      </div>
    </>
  );
}